module.exports = __webpack_public_path__ + "static/media/NiaDayGuideHeader2.bc0bae9c.png";